import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=3906e4b9&scoped=true"
import script from "./BoxCard.vue?vue&type=script&lang=js"
export * from "./BoxCard.vue?vue&type=script&lang=js"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=3906e4b9&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=3906e4b9&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906e4b9",
  null
  
)

export default component.exports